export default __webpack_public_path__ + "static/media/featured_area_oshawa.42ce65b5.webp";